import ModalState from 'redux/modal/interfaces/modalState';

const INIT_MODAL_STATE: ModalState = {
  isOpen: false,
  closing: false,
  config: null,
};

export default INIT_MODAL_STATE;
